import { Icon } from '@winnin/ds-icon'
// Imported by full path on purpose: the bare specifier is aliased to this component in
// vite.config.mts, so importing it here would resolve back to itself.
import { ProviderIcon as BitProviderIcon } from '@winnin/winnin_ui.components.provider-icon/dist/index.js'

import type { IProviderIconProps } from './provider-icon.types'

export const ProviderIcon = ({
  icon,
  width,
  height,
  className,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
}: IProviderIconProps) => {
  if (icon !== 'yt') {
    return <BitProviderIcon icon={icon} width={width} height={height} className={className} />
  }

  return (
    <Icon
      name="youtube"
      role="img"
      aria-label={ariaLabel ?? 'YouTube'}
      className={className}
      width={width}
      height={height}
      data-testid={dataTestId ?? 'providerIcon-yt'}
    />
  )
}

// The design system packages that render the provider icon themselves (provider-button,
// creator-card-*, video-card-big) are CommonJS, and `@winnin/winnin_ui.components.provider-icon` is
// aliased to this file for them too. Vite's dep pre-bundling turns their `require(...)` into a
// *default* import of this module, so without a default export they fail to load with "does not
// provide an export named 'default'". Those packages only ever read `.ProviderIcon` off the
// namespace, so the default mirrors the real package's CJS module shape rather than being the
// component itself.
// eslint-disable-next-line import-x/no-unused-modules -- consumed by aliased CJS design system packages, not by app code
export default { ProviderIcon }
